import PasesSalidaScreen from "../../Screen/ERP/Logistica/PasesSalida/PasesSalidaScreen";
import RequisasMaterialesScreen from "../../Screen/ERP/Suministros/Bodegas/RequisasMateriales/RequisasMaterialesScreen";



export const Logistica = [
  {
    path: "Logistica/PasesSalida",
    permiso: 68,
    element: <PasesSalidaScreen />,
  },
  {
    path: "Logistica/LiberarPases",
    permiso: 69,
    element: <PasesSalidaScreen Firma={1} PendienteRetorno={false} />,
  },
  {
    path: "Logistica/PendienteRetorno",
    permiso: 109,
    element: <PasesSalidaScreen PendienteRetorno={true} />,
  },

];
  
export default Logistica;
  